var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcaml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ocaml-original-a",
    gradientUnits: "userSpaceOnUse",
    x1: 82.925,
    y1: 97.718,
    x2: 82.925,
    y2: 97.9,
    gradientTransform: "translate(0 8.224) scale(.77317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F29100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC670F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ocaml-original-b",
    gradientUnits: "userSpaceOnUse",
    x1: 61.276,
    y1: 98.981,
    x2: 61.276,
    y2: 144.277,
    gradientTransform: "translate(0 8.224) scale(.77317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F29100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC670F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ocaml-original-c",
    gradientUnits: "userSpaceOnUse",
    x1: 82.781,
    y1: 0,
    x2: 82.781,
    y2: 144.245,
    gradientTransform: "translate(0 8.224) scale(.77317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F29100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC670F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ocaml-original-d",
    gradientUnits: "userSpaceOnUse",
    x1: 22.871,
    y1: 92.114,
    x2: 22.871,
    y2: 143.249,
    gradientTransform: "translate(0 8.224) scale(.77317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F29100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC670F"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.11 83.918l.019-.047c-.027-.117-.035-.148-.02.047zm0 0",
    fill: "#484444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.11 83.918l.019-.047c-.027-.117-.035-.148-.02.047zm0 0",
    fill: "url(#ocaml-original-a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.969 115.441c-.45-.937-1.016-2.773-1.39-3.582-.356-.754-1.434-2.722-1.974-3.355-1.175-1.375-1.453-1.477-1.796-3.215-.602-3.023-2.192-8.508-4.067-12.293-.969-1.953-2.578-3.594-4.05-5.012-1.286-1.242-4.184-3.332-4.692-3.226-4.734.945-6.203 5.59-8.434 9.27-1.23 2.034-2.535 3.765-3.507 5.929-.899 1.992-.817 4.195-2.352 5.902-1.578 1.758-2.602 3.625-3.371 5.891-.148.43-.563 4.953-1.016 6.027l7.04-.496c6.558.45 4.663 2.965 14.902 2.414l16.164-.5c-.504-1.48-1.196-3.195-1.461-3.754zm0 0",
    fill: "url(#ocaml-original-b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.875 8.223H16.133C7.227 8.227.008 15.445.008 24.352v35.183c2.308-.836 5.625-5.742 6.664-6.937 1.82-2.086 2.148-4.75 3.055-6.426 2.066-3.82 2.421-6.445 7.109-6.445 2.187 0 3.055.503 4.535 2.488 1.027 1.379 2.809 3.93 3.637 5.633.96 1.968 2.527 4.629 3.215 5.164.511.402 1.015.699 1.488.875.758.289 1.39-.235 1.898-.64.649-.52.93-1.571 1.532-2.977.867-2.028 1.808-4.458 2.347-5.31.93-1.464 1.246-3.202 2.25-4.046 1.485-1.242 3.414-1.328 3.95-1.434 2.976-.59 4.328 1.434 5.792 2.743.961.855 2.27 2.582 3.204 4.89.726 1.809 1.652 3.48 2.039 4.524.375 1.004 1.3 2.62 1.847 4.55.496 1.758 1.828 3.106 2.332 3.938 0 0 .774 2.168 5.48 4.152 1.02.43 3.083 1.13 4.313 1.575 2.047.746 4.028.648 6.551.347 1.797 0 2.774-2.605 3.59-4.691.484-1.23.945-4.766 1.262-5.766.304-.976-.41-1.73.199-2.586.71-1 1.133-1.054 1.543-2.355.883-2.785 5.984-2.926 8.847-2.926 2.399 0 2.086 2.32 6.141 1.527 2.32-.457 4.559.297 7.024.95 2.074.55 4.023 1.175 5.195 2.546.758.887 2.633 5.325.719 5.516.183.223.32.629.664.852-.426 1.675-2.282.48-3.309.265-1.39-.285-2.367.043-3.726.645-2.32 1.035-5.715.914-7.739 2.597-1.715 1.43-1.71 4.614-2.511 6.399 0 0-2.223 5.719-7.075 9.215-1.242.898-3.668 3.054-8.953 3.87-2.367.368-4.586.395-7.02.274l-3.511-.133c-.695-.003-3.063-.082-2.945.145l-.266.656c.043.219.129.754.152.887.098.527.125.95.145 1.437.035 1-.082 2.043-.031 3.055.105 2.094.882 4.008.98 6.121.11 2.356 1.274 4.844 2.399 6.77.43.73 1.078.812 1.363 1.715.332 1.03.02 2.129.18 3.23.632 4.266 1.855 8.73 3.785 12.582a.685.685 0 00.043.094c2.375-.395 4.754-1.25 7.84-1.707 5.652-.836 13.519-.406 18.57-.88 12.781-1.198 19.719 5.243 31.203 2.602V24.352c-.004-8.907-7.223-16.13-16.129-16.13zM64.109 83.918c-.015-.195-.007-.168.02-.047zm0 0",
    fill: "url(#ocaml-original-c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.516 98.727c.89-1.946 1.406-4.165 2.144-6.157.711-1.906 1.817-4.61 3.7-5.57-.227-.27-3.938-.39-4.93-.492l-3.2-.453-6.164-1.27c-1.199-.289-5.187-1.703-6.054-2.101-2.032-.938-3.383-3.48-4.969-3.22-1.016.165-2.012.513-2.633 1.536-.515.836-.691 2.27-1.047 3.23-.414 1.118-1.129 2.16-1.754 3.223-1.152 1.95-3.222 3.715-4.113 5.617-.18.39-.34.828-.488 1.285v21.735l3.347.722c8.993 2.403 11.188 2.606 20.008 1.594l.828-.11c.672-1.405 1.196-6.187 1.633-7.667.34-1.137.809-2.04.988-3.2.168-1.1-.015-2.148-.113-3.152-.242-2.504 1.828-3.398 2.82-5.55zm0 0",
    fill: "url(#ocaml-original-d)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcaml);
export default __webpack_public_path__ + "static/media/ocaml.627772338758d8309154eea91aeb4227.svg";
export { ForwardRef as ReactComponent };